var privateBase64ToByte = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    removePaddingChars: function (input) {
        var lkey = this._keyStr.indexOf(input.charAt(input.length - 1));
        if (lkey == 64) {
            return input.substring(0, input.length - 1);
        }
        return input;
    },

    decode: function (input) {
        //get last chars to see if are valid
        input = this.removePaddingChars(input);
        input = this.removePaddingChars(input);

        var bytes = parseInt((input.length / 4) * 3, 10);

        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var j = 0;

        var uarray = new Uint8Array(bytes);

        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        for (var i = 0; i < bytes; i += 3) {
            //get the 3 octects in 4 ascii chars
            enc1 = this._keyStr.indexOf(input.charAt(j++));
            enc2 = this._keyStr.indexOf(input.charAt(j++));
            enc3 = this._keyStr.indexOf(input.charAt(j++));
            enc4 = this._keyStr.indexOf(input.charAt(j++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            uarray[i] = chr1;
            if (enc3 != 64) uarray[i + 1] = chr2;
            if (enc4 != 64) uarray[i + 2] = chr3;
        }

        return uarray;
    }
};


class Converter {

    /**
     * 将数字转为4位Byte数组
     */
    intToBytes(int) {
        var bytes = new Array();
        bytes.push((int >> 0) & 0xff);
        bytes.push((int >> 8) & 0xff);
        bytes.push((int >> 16) & 0xff);
        bytes.push((int >> 24) & 0xff);
        return bytes;
    };

    /**
     * 将4位Byte数组转为数字
     */
    bytesToInt(bytes) {
        return (bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24) >>> 0;
    };

    /**
     * 将Long转为8位数组
     */
    longToBytes(strLong) {
        if (typeof (strLong) !== "string") console.error("请传入一个Long型字符串");
        var arrayBuffer = new ArrayBuffer(8);
        var array = new BigInt64Array(arrayBuffer);
        array[0] = BigInt(strLong);
        return this.unitToArray(new Uint8Array(arrayBuffer));
    };
    /**
     * 将8位数组转为Long
     */
    bytesToLong(array) {
        var arrayBuffer = new ArrayBuffer(8);
        var uint8Array = new Uint8Array(arrayBuffer);
        array.forEach(function (item, index) {
            uint8Array[index] = array[index];
        });
        return (new BigInt64Array(arrayBuffer))[0];
    };

    /**
     * 将字符串转为Byte数组
     */
    stringToBytes(str) {
        var bytes = new Array();
        if (str) {
            var len, c;
            len = str.length;
            for (var i = 0; i < len; i++) {
                c = str.charCodeAt(i);
                if (c >= 0x010000 && c <= 0x10FFFF) {
                    bytes.push(((c >> 18) & 0x07) | 0xF0);
                    bytes.push(((c >> 12) & 0x3F) | 0x80);
                    bytes.push(((c >> 6) & 0x3F) | 0x80);
                    bytes.push((c & 0x3F) | 0x80);
                } else if (c >= 0x000800 && c <= 0x00FFFF) {
                    bytes.push(((c >> 12) & 0x0F) | 0xE0);
                    bytes.push(((c >> 6) & 0x3F) | 0x80);
                    bytes.push((c & 0x3F) | 0x80);
                } else if (c >= 0x000080 && c <= 0x0007FF) {
                    bytes.push(((c >> 6) & 0x1F) | 0xC0);
                    bytes.push((c & 0x3F) | 0x80);
                } else {
                    bytes.push(c & 0xFF);
                }
            }
        }
        return bytes;
    };
    /**
     * 将Byte数组转为字符串
     */
    bytesToString(arr) {
        if (typeof arr === 'string') {
            return arr;
        }
        var str = '',
            _arr = arr;
        for (var i = 0; i < _arr.length; i++) {
            var one = _arr[i].toString(2),
                v = one.match(/^1+?(?=0)/);
            if (v && one.length == 8) {
                var bytesLength = v[0].length;
                var store = _arr[i].toString(2).slice(7 - bytesLength);
                for (var st = 1; st < bytesLength; st++) {
                    store += _arr[st + i].toString(2).slice(2);
                }
                str += String.fromCharCode(parseInt(store, 2));
                i += bytesLength - 1;
            } else {
                str += String.fromCharCode(_arr[i]);
            }
        }
        return str;
    };

    /**
     * 将Uint8Array类型转为Array
     */
    unitToArray(unitArray) {
        var array = [];
        unitArray.forEach(function (item, index) {
            array.push(item);
        });
        return array;
    };
    /**
     * 将base64转为bytes数组
     */
    base64ToBytes(base64) {
        return this.unitToArray(privateBase64ToByte.decode(base64));
    };
    /**
     * 将Byte数组转为base64
     */
    bytesToBase64(buffer) {
        var strBase64 = '';
        var bytes = new Uint8Array(buffer);
        for (var i = 0; i < bytes.byteLength; i++) {
            strBase64 += String.fromCharCode(bytes[i]);
        }
        return window.btoa(strBase64);
    };
    
    /**
     * 将Byte数组转为16进制字符串
     * @param {*} bytes 
     * @returns 
     */
    bytesToHex(bytes) {
        for (var hex = [], i = 0; i < bytes.length; i++) {
            hex.push((bytes[i] >>> 4).toString(16));
            hex.push((bytes[i] & 0xF).toString(16));
        }
        return hex.join("");
    }

    /** 
     * 获取DateTime的Ticks
     */
    dateTimeTicks(date) {
        var dateTime = date || new Date();
        // 621356256000000000 
        return (62135625600000 + dateTime.getTime()) + "0000";
    }

    
}

export default new Converter();